import React, { useEffect, useState } from "react";
import { fetchWithAuth } from "../config/api";
import BookingApprovals from "./BookingApprovals";
import StaffAssignments from "./StaffAssignments";
import StaffWorkingDays from "./StaffWorkingDays";
import StaffManager from "./StaffManager";
import ServiceManager from "./ServiceManager";
import ResignedStaff from "./ResignedStaff";

// Staff and Services change pay, roles, logins and the price list, so those two
// tabs are only offered to admins and managers. The server enforces this as
// well -- hiding a button is a convenience, not a permission check.
const MANAGER_ONLY = ["staff", "resigned", "services"];

const TABS = [
  { key: "approvals", label: "Booking Approvals" },
  { key: "assignments", label: "Staff Assignments" },
  { key: "working-days", label: "Staff Working Days" },
  { key: "staff", label: "Staff" },
  { key: "resigned", label: "Resigned Staff" },
  { key: "services", label: "Services" },
];

export default function ControlCenter() {
  const [tab, setTab] = useState("approvals");
  const [canManage, setCanManage] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetchWithAuth("/api/user/permissions/");
        const js = await res.json().catch(() => ({}));
        if (cancelled) return;
        const role = (js.role || "").toLowerCase();
        setCanManage(Boolean(js.is_superuser) || role === "admin" || role === "manager");
      } catch {
        if (!cancelled) setCanManage(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const visibleTabs = TABS.filter((t) => canManage || !MANAGER_ONLY.includes(t.key));

  // If the role check resolves after a hidden tab was somehow selected, fall
  // back to the first tab the user is allowed to see.
  const activeTab = visibleTabs.some((t) => t.key === tab) ? tab : visibleTabs[0].key;

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", gap: 8, marginBottom: 16 }}>
        <h3 style={{ margin: 0 }}>Settings</h3>
      </div>

      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 16 }}>
        {visibleTabs.map((t) => (
          <button
            key={t.key}
            className="btn"
            type="button"
            onClick={() => setTab(t.key)}
            style={
              activeTab === t.key
                ? { outline: "2px solid #333", outlineOffset: 2 }
                : { opacity: 0.85 }
            }
            aria-current={activeTab === t.key ? "page" : undefined}
          >
            {t.label}
          </button>
        ))}
      </div>

      {activeTab === "approvals" && <BookingApprovals />}
      {activeTab === "assignments" && <StaffAssignments />}
      {activeTab === "working-days" && <StaffWorkingDays />}
      {activeTab === "staff" && <StaffManager />}
      {activeTab === "resigned" && <ResignedStaff />}
      {activeTab === "services" && <ServiceManager />}
    </div>
  );
}
